import classNames from "classnames";
import { LOADING_BAR_STATUS } from "../../constants/loadingBarStatus";
import { useLoadingBar } from "../../contexts/LoadingBarProvider";
import "./LoadingBar.scss";

export const LoadingBar = () => {
	const { status } = useLoadingBar();

	return (
		<div
			className={classNames(
				{
					"loading-bar--loading": status === LOADING_BAR_STATUS.LOADING,
					"loading-bar--finished": status === LOADING_BAR_STATUS.FINISHED,
				},
				"loading-bar"
			)}
		/>
	);
};
